// extracted by mini-css-extract-plugin
export default {"facetMenu":"GB-z","fixed":"HB-z","nonLayerdFacets":"IB-z","productCount":"JB-z","facetBack":"KB-z","arrow":"LB-z","facetClose":"MB-z"};